import { Component, Host, h, State, Element, Listen } from '@stencil/core';

@Component({
    tag: 'sew-ws-tab-navigation',
    styleUrl: 'sew-ws-tab-navigation.scss',
    shadow: true,
})
export class SewWsTabNavigation {
    @Element() host: HTMLSewWsTabNavigationElement;

    @State() isScrollableToLeft = false;
    @State() isScrollableToRight = false;

    private tabNavRef: HTMLElement;

    private checkScrollable = () => {
        const maxScrollLeft = this.tabNavRef.scrollWidth - this.tabNavRef.clientWidth;

        if (this.tabNavRef.scrollLeft === 0) {
            this.isScrollableToLeft = false;
        } else {
            this.isScrollableToLeft = true;
        }

        if (this.tabNavRef.scrollLeft >= maxScrollLeft) {
            this.isScrollableToRight = false;
        } else {
            this.isScrollableToRight = true;
        }
    };

    @Listen('tabNavItemClicked')
    activeTabHandler(event: Event): void {
        const rectTabNav = this.tabNavRef.getBoundingClientRect();
        const rectTabItem = (event.target as HTMLElement).getBoundingClientRect();

        if (rectTabNav.right < Math.round(rectTabItem.right)) {
            this.tabNavRef.scrollLeft += rectTabItem.width;
        } else if (rectTabNav.left > rectTabItem.left) {
            this.tabNavRef.scrollLeft -= rectTabItem.width;
        }

        this.checkScrollable();
    }

    private resizeObserver: ResizeObserver = new ResizeObserver(this.checkScrollable);

    private scrollToLeft = () => {
        this.tabNavRef.scrollLeft -= 100;
    };

    private scrollToRight = () => {
        this.tabNavRef.scrollLeft += 100;
    };

    componentDidLoad(): void {
        this.resizeObserver.observe(this.tabNavRef);
    }

    render() {
        return (
            <Host>
                <button
                    class={{
                        'scroll-btn': true,
                        'scroll-btn--left': true,
                        '--hide': !this.isScrollableToLeft,
                    }}
                    onClick={this.scrollToLeft}
                >
                    <sew-icon class="svg" icon="arrow-chevron-left" height="28" width="28" />
                </button>

                <div class="tabs-nav" onScroll={this.checkScrollable} ref={ref => (this.tabNavRef = ref)}>
                    <slot onSlotchange={this.checkScrollable}></slot>
                </div>

                <button
                    class={{
                        'scroll-btn': true,
                        'scroll-btn--right': true,
                        '--hide': !this.isScrollableToRight,
                    }}
                    onClick={this.scrollToRight}
                >
                    <sew-icon class="svg" icon="arrow-chevron-right" height="28" width="28" />
                </button>
            </Host>
        );
    }
}
